export const STORE_ITEM_PREVIEW_TABS = {
  ITEM_DETAILS: 'item-details',
  VENDOR_DETAILS: 'vendor-details'
};
